var _ellipse, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfo3 = function SvgInfo3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 160 160"
  }, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 80,
    cy: 130,
    fill: "#0C0C0D",
    opacity: 0.2,
    rx: 60,
    ry: 15
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 80,
    r: 50,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#757676",
    d: "M139.199 69.859c-4.08-24.844-24.123-44.946-49.026-49.027-41.046-6.72-76.03 28.264-69.31 69.31 4.08 24.843 24.123 44.945 49.027 49.026 41.045 6.721 76.03-28.264 69.309-69.31zm-52.867 40.565a2.56 2.56 0 0 1-2.58 2.58H76.37a2.56 2.56 0 0 1-2.58-2.58V72.739c0-1.32.96-2.4 2.22-2.58l7.38-1.02c1.56-.24 2.941 1.02 2.941 2.58v38.705zm-6.36-49.147c-4.321 0-7.262-3.12-7.262-7.08 0-3.961 2.94-7.202 7.261-7.202 4.38 0 7.321 3.181 7.321 7.202.06 3.96-2.94 7.08-7.32 7.08z"
  })));
};
export { SvgInfo3 as ReactComponent };
export default __webpack_public_path__ + "assets/info-3.svg";